<app-page>
  <div class="flex flex-column align-items-center justify-content-center h-full p-1 gap-3">
    <div class="flex align-items-center justify-content-between gap-3">
      <div>
        <div class="text-2xl">Oooops!</div>
        <div class="text-base">C'è un problema...</div>
        <div class="text-base">La pagina che cercavi non l'ho trovata :(</div>
      </div>
      <div><img alt="image" class="h-12rem" src="./assets/images/404.png"></div>
    </div>
  </div>
</app-page>
